import React, { useState, useContext } from "react";
import { LoaderWrapper, ManageTempMapLayout } from "../../../components";
import { isEmpty, get, isNull } from "lodash";
import SourceContainer from "./SourceContainer";
import TargetContainer from "./TargetContainer";
import { DragDropContext } from "react-beautiful-dnd";
import { Row, Col } from "react-bootstrap";
import {
  manageMapperStore,
  setManageMapperToastInfo,
  setFileUploadData,
  setMapperPostRequest,
  setMapperPostResponse,
  MANAGE_MAPPER_POST_API_ERROR,
} from "../../../contexts";
import { Formik } from "formik";

import SampleData from "../../Mapper/MapperHomeContainer/SampleData";
import {
  CensusAndPayroll,
  Payroll,
  Census,
  FLOW_TYPES,
  ROUTES,
  MANAGE_PAYROLL_ROUTES,
} from "../../../utils";
import { onMappingChange } from "../../../services";
import { useDeepEffect, useRouterParams } from "../../../abstracts";
import { default as uuid } from "uuid";
const columns = {
  source: {
    id: "source container",
    title: "source",
    data: SampleData,
  },
};

const MapandTransformContainer = (props) => {
  const { state, dispatch } = useContext(manageMapperStore);
  const { flow, profileId } = useRouterParams();
  const isEdit = flow === FLOW_TYPES.EDIT;
  const uploadedFileType = get(state, "api.data.uploadedFileType");
  const headersJson = get(state, "api.data.headerMapJson");

  const fileUpload = get(state, "api.fileuploadData", []);
  const fileuploadData = JSON.stringify(get(fileUpload, "row"));
  const fileUploadFields = !isEmpty(fileuploadData)
    ? fileuploadData
    : get(fileUpload, "mappingConfiguration.headerMapJson", "");
  const fieldHeadersJson = isEmpty(fileUpload) ? headersJson : fileUploadFields;
  const [characters, setCharacters] = useState();
  const [dragStart, setDrag] = useState(false);
  const [addConfigureSlider, setConfigureSlider] = useState(false);
  const [dest, setDestination] = useState("");
  const [mapped, setMapped] = useState("");
  const mappingData = isEmpty(fileUpload)
    ? get(state, "api.data", [])
    : get(state, "api.fileuploadData.mappingConfiguration", []);
  const [ssnExist, setSsnExist] = useState(true);
  const [rkPlanNumberExist, setRkPlanNumberExist] = useState(true);
  const data = isEdit
    ? get(mappingData, "objectMaps", []).filter((e) => isEmpty(e.parent))
    : get(mappingData, "objectMaps", []);

  const [ct, setCT] = useState([]);
  const nonCollections = !isEmpty(data)
    ? data.filter((f) => !f.isCollection)
    : [];
  const targetData =
    uploadedFileType == 3
      ? CensusAndPayroll
      : uploadedFileType == 2
      ? Payroll
      : Census;
  const requiredObjects = targetData.map((e) => {
    const d = nonCollections.find((g) => g.propertyName == e.propertyName);
    if (!isEmpty(d)) {
      return {
        ...d,
        tId: uuid.v4(),
        groupName: e.groupName,
        displayName: e.displayName,
      };
    }
    return e;
  });

  useDeepEffect(() => {
    setCharacters(JSON.parse(fieldHeadersJson));
  }, [fieldHeadersJson]);

  const collections = !isEmpty(data) ? data.filter((f) => f.isCollection) : [];

  const requiredCollections = !isEmpty(collections)
    ? collections.map((e) => {
        const childs = !isEmpty(e.childObjectMaps)
          ? e.childObjectMaps.map((f) => ({
              ...f,
              tId: uuid.v4(),
            }))
          : [];
        const existingChilds = targetData.find(
          (g) => g.propertyName == e.propertyName
        );
        const c = !isEmpty(get(existingChilds, "childObjectMaps"))
          ? get(existingChilds, "childObjectMaps").map((f) => {
              const d = childs.find((g) => g.propertyName == f.propertyName);
              if (!isEmpty(d)) {
                return {
                  ...d,
                  displayName: f.displayName,
                };
              }
              return f;
            })
          : [];
        return {
          ...e,
          tId: uuid.v4(),
          groupName: get(existingChilds, "groupName"),
          childObjectMaps: c,
        };
      })
    : [];

  const wholeObject = requiredObjects.filter((e) =>
    isEmpty(requiredCollections.find((g) => g.propertyName == e.propertyName))
  );

  const [targetField, setTargetField] = useState(
    !isEmpty(wholeObject)
      ? [...wholeObject, ...requiredCollections]
      : targetData
  );
  const [dataLoading, setDataLoading] = useState(false);
  const SaveMapping = () => {
    const { history } = props;
    const groupItems = targetField.filter((e) => e.isCollection);
    const groups = groupItems
      .map((e) => {
        if (!isEmpty(e.childObjectMaps)) {
          return {
            id: get(e, "id", 0),
            constantValue:
              e.dataType === 4
                ? e.constantValue
                : e["constantValue"]?.toLowerCase() === "@filename"
                ? "@FileName"
                : "",
            dataSource: get(e, "dataSource", 1),
            fieldOperations: [],
            isCollection: e.isCollection,
            isCollectionEnd: e.isCollectionEnd,
            isCollectionStart: e.isCollectionStart,
            isComplex: get(e, "isComplex", false),
            propertyName: e.propertyName,
            sortOrder: e.sortOrder,
            childObjectMaps: e.childObjectMaps
              .filter(
                (f) =>
                  !isEmpty(f.path) &&
                  characters?.map((x) => x.fieldName).includes(f.path)
              )
              .map((e) => {
                return {
                  id: get(e, "id", 0),
                  constantValue: get(e, "constantValue", ""),
                  childObjectMaps: get(e, "childObjectMaps", []),
                  dataType: e.dataType,
                  dataSource: get(e, "dataSource", 1),
                  fieldOperations:
                    get(e, "dataSource", 1) == 3 ||
                    (get(e, "fieldOperations", []).length == 1 &&
                      get(e, "fieldOperations", [])[0].transformation == "")
                      ? []
                      : get(e, "fieldOperations", []),
                  isCollection: get(e, "isCollection", false),
                  isCollectionEnd: get(e, "isCollectionEnd", false),
                  isCollectionStart: get(e, "isCollectionStart", false),
                  isComplex: get(e, "isComplex", false),
                  path: get(e, "path", null),
                  propertyName: e.propertyName,
                  sortOrder: e.sortOrder,
                };
              }),
          };
        }
      })
      .filter((f) => !isEmpty(f.childObjectMaps));

    const requiredFields =
      !isEmpty(targetField) &&
      targetField
        .filter((e) => !isEmpty(e.path))
        .map((e) => ({
          id: get(e, "id", 0),
          constantValue:
            e.dataType === 4
              ? e.constantValue
              : e["constantValue"]?.toLowerCase() === "@filename"
              ? "@FileName"
              : e["constantValue"],
          childObjectMaps: get(e, "childObjectMaps", []),
          dataType: e.dataType,
          dataSource: get(e, "dataSource", 1),
          fieldOperations:
            get(e, "dataSource", 1) == 3 ||
            (get(e, "fieldOperations", []).length == 1 &&
              get(e, "fieldOperations", [])[0].transformation == "")
              ? []
              : get(e, "fieldOperations", []),
          isCollection: e.isCollection,
          isCollectionEnd: get(e, "isCollectionEnd", false),
          isCollectionStart: get(e, "isCollectionStart", false),
          isComplex: get(e, "isComplex", false),
          path: get(e, "path", null),
          propertyName: e.propertyName,
          sortOrder: e.sortOrder,
        }));
    const ids = groups.map((_) => _?.id);
    const filteredRequiredFields = requiredFields.filter(
      (_) => !ids.includes(_?.id) || _?.id == 0
    );
    const finalFields = filteredRequiredFields.filter((f) =>
      characters
        ?.map((x) => x.fieldName?.replaceAll("/", ""))
        .includes(f.path?.replaceAll("/", ""))
    );

    const payload = {
      ...get(state, "api.data"),
      objectMaps: [...finalFields, ...groups],
    };

    let isSsnExists = !isEmpty(
      payload?.objectMaps?.filter(
        (item) => item?.propertyName == "UniquePersonalIdentification"
      )
    );
    let isRkPlanNumberExists = !isEmpty(
      payload?.objectMaps?.filter(
        (item) => item?.propertyName == "RKPlanNumber"
      )
    );
    if (isSsnExists && isRkPlanNumberExists) {
      setDataLoading(true);
      dispatch(setMapperPostRequest());
      onMappingChange(payload)
        .then((res) => {
          setDataLoading(false);

          if (!isEmpty(res)) {
            history.push(`${MANAGE_PAYROLL_ROUTES.VERIFY_MAP}/${profileId}`);
            dispatch(setMapperPostResponse(res));
            if (!isEmpty(fileUpload)) {
              dispatch(
                setFileUploadData({
                  row: get(state, "api.fileuploadData.row", []),
                  mappingConfiguration: res,
                })
              );
            }

            dispatch(
              setManageMapperToastInfo({
                showToast: true,
                toastMessage: "Data saved successfully",
              })
            );
            return null;
          } else {
            dispatch({
              type: MANAGE_MAPPER_POST_API_ERROR,
              payload: "Something went wrong! please try again.",
            });
          }
        })
        .catch((err) => {
          setDataLoading(false);
          dispatch({
            type: MANAGE_MAPPER_POST_API_ERROR,
            payload: "Something went wrong! please try again.",
          });
        });
    } else {
      setSsnExist(false);
      setRkPlanNumberExist(false);
    }
  };

  const buttons = [
    {
      label: "Cancel",
      variant: "secondary",
      type: "button",
      link: ROUTES.PAYROLL,
    },
    {
      label: "Next",
      variant: "primary",
      type: "submit",
      onClick: SaveMapping,
    },
  ];

  const onCancelConfigure = () => {
    setConfigureSlider(false);
  };

  const setConfigure = () => {
    //setConfigureSlider(!addConfigureSlider);
  };

  const handleOnDragStart = () => {
    setDrag(true);
  };
  const handleOnDragUpdate = (update) => {
    const { destination } = update;
    if (!isNull(destination)) {
      setDestination(destination.droppableId);
    }
  };

  const handleOnDragEnd = (result) => {
    setDrag(false);
    setDestination(null);
    const { source, destination } = result;

    if (isEmpty(result.destination)) {
      setDestination("");
      return;
    }

    const draggedData = destination.droppableId.includes(",", 35)
      ? targetField.map((e, i) => {
          if (destination.droppableId.includes(",", 35)) {
            const Tids = destination.droppableId.split(",");
            if (e.tId == Tids[1]) {
              const childMaps = e.childObjectMaps.map((f) =>
                f.tId == Tids[0]
                  ? {
                      ...f,
                      path: characters.find(
                        (g) => g.fieldName == result.draggableId
                      ).fieldName,
                    }
                  : f
              );
              return {
                ...e,
                childObjectMaps: childMaps,
              };
            }
            return e;
          }
          return e;
        })
      : targetField.map((e, i) => {
          if (e.tId == destination.droppableId) {
            return {
              ...e,
              path: characters.find((f) => f.fieldName == result.draggableId)
                .fieldName,
            };
          }
          return e;
        });
    setTargetField(draggedData);
  };

  const setFieldOperations = (dataSource, operations, itemConfigures) => {
    const itemConfigure = itemConfigures.object;

    const transformations =
      !isEmpty(ct) && ct.length > 1
        ? !isEmpty(ct.find((e) => e.propertyName == itemConfigure.propertyName))
          ? ct.map((e, i) => {
              if (e.propertyName == itemConfigure.propertyName) {
                return {
                  id: e.id,
                  isCollection: e.isCollection,
                  isCollectionStart: e.isCollectionStart,
                  isCollectionEnd: e.isCollectionEnd,
                  groupName: e.groupName,
                  displayName: e.displayName,
                  propertyName: e.propertyName,
                  dataType: e.dataType,
                  format: e.format,
                  fieldLength: e.fieldLength,
                  isRequired: e.isRequired,
                  childObjectMaps: e.childObjectMaps,
                  fieldOperations: operations,
                  isComplex: e.isComplex,
                  mappingConfigurationId: get(state, "api.data.id", 0),
                  parent: e.parent,
                  parentId: e.parentId,
                  path: e.path,
                  sortOrder: e.sortOrder,
                  index: e.index,
                  constantValue: e.constantValue,
                  dataSource: dataSource,
                };
              }
              return e;
            })
          : [
              ...ct,
              {
                id: itemConfigure.id,
                isCollection: itemConfigure.isCollection,
                isCollectionStart: itemConfigure.isCollectionStart,
                isCollectionEnd: itemConfigure.isCollectionEnd,
                groupName: itemConfigure.groupName,
                displayName: itemConfigure.displayName,
                propertyName: itemConfigure.propertyName,
                dataType: itemConfigure.dataType,
                format: itemConfigure.format,
                fieldLength: itemConfigure.fieldLength,
                isRequired: itemConfigure.isRequired,
                childObjectMaps: itemConfigure.childObjectMaps,
                fieldOperations: operations,
                isComplex: itemConfigure.isComplex,
                mappingConfigurationId: get(state, "api.data.id", 0),
                parent: itemConfigure.parent,
                parentId: itemConfigure.parentId,
                path: itemConfigure.path,
                sortOrder: itemConfigure.sortOrder,
                index: itemConfigure.index,
                constantValue: itemConfigure.constantValue,
                dataSource: dataSource,
              },
            ]
        : isEmpty(ct)
        ? [
            {
              id: itemConfigure.id,
              isCollection: itemConfigure.isCollection,
              isCollectionStart: itemConfigure.isCollectionStart,
              isCollectionEnd: itemConfigure.isCollectionEnd,
              groupName: itemConfigure.groupName,
              displayName: itemConfigure.displayName,
              propertyName: itemConfigure.propertyName,
              dataType: itemConfigure.dataType,
              format: itemConfigure.format,
              fieldLength: itemConfigure.fieldLength,
              isRequired: itemConfigure.isRequired,
              childObjectMaps: itemConfigure.childObjectMaps,
              fieldOperations: operations,
              isComplex: itemConfigure.isComplex,
              mappingConfigurationId: get(state, "api.data.id", 0),
              parent: itemConfigure.parent,
              parentId: itemConfigure.parentId,
              path: itemConfigure.path,
              sortOrder: itemConfigure.sortOrder,
              index: itemConfigure.index,
              constantValue: itemConfigure.constantValue,
              dataSource: dataSource,
            },
          ]
        : ct.find((e) => e.propertyName == itemConfigure.propertyName)
        ? [
            {
              id: itemConfigure.id,
              isCollection: itemConfigure.isCollection,
              isCollectionStart: itemConfigure.isCollectionStart,
              isCollectionEnd: itemConfigure.isCollectionEnd,
              groupName: itemConfigure.groupName,
              displayName: itemConfigure.displayName,
              propertyName: itemConfigure.propertyName,
              dataType: itemConfigure.dataType,
              format: itemConfigure.format,
              fieldLength: itemConfigure.fieldLength,
              isRequired: itemConfigure.isRequired,
              childObjectMaps: itemConfigure.childObjectMaps,
              fieldOperations: operations,
              isComplex: itemConfigure.isComplex,
              mappingConfigurationId: get(state, "api.data.id", 0),
              parent: itemConfigure.parent,
              parentId: itemConfigure.parentId,
              path: itemConfigure.path,
              sortOrder: itemConfigure.sortOrder,
              index: itemConfigure.index,
              constantValue: itemConfigure.constantValue,
              dataSource: dataSource,
            },
          ]
        : [
            ...ct,
            {
              id: itemConfigure.id,
              isCollection: itemConfigure.isCollection,
              isCollectionStart: itemConfigure.isCollectionStart,
              isCollectionEnd: itemConfigure.isCollectionEnd,
              groupName: itemConfigure.groupName,
              displayName: itemConfigure.displayName,
              propertyName: itemConfigure.propertyName,
              dataType: itemConfigure.dataType,
              format: itemConfigure.format,
              fieldLength: itemConfigure.fieldLength,
              isRequired: itemConfigure.isRequired,
              childObjectMaps: itemConfigure.childObjectMaps,
              fieldOperations: operations,
              isComplex: itemConfigure.isComplex,
              mappingConfigurationId: get(state, "api.data.id", 0),
              parent: itemConfigure.parent,
              parentId: itemConfigure.parentId,
              path: itemConfigure.path,
              sortOrder: itemConfigure.sortOrder,
              index: itemConfigure.index,
              constantValue: itemConfigure.constantValue,
              dataSource: dataSource,
            },
          ];

    setCT(transformations);
  };
  return (
    <LoaderWrapper isLoading={dataLoading}>
      <ManageTempMapLayout buttons={buttons}>
        <Formik
          initialValues={{}}
          enableReinitialize
          onSubmit={() => {}}
          validateOnChange={false}
          validateOnBlur={false}
        >
          {({
            errors,
            values,
            touched,
            setValues,
            handleChange,
            setFieldValue,
            handleSubmit,
          }) => {
            return (
              <DragDropContext
                onDragStart={handleOnDragStart}
                onDragUpdate={handleOnDragUpdate}
                onDragEnd={handleOnDragEnd}
              >
                <div className="mapper-container marg-top-30">
                  <Row>
                    <Col sm={4} xs={4} md={4} lg={4}>
                      <SourceContainer
                        column={get(columns, "source.id")}
                        setCharacters={setCharacters}
                        mapped={mapped}
                        characters={
                          characters
                            ? characters.map((e) => {
                                const filtered = targetField.filter(
                                  (f) =>
                                    f.path?.replaceAll("/", "") ==
                                    e.fieldName?.replaceAll("/", "")
                                );
                                const groups = targetField
                                  .filter((f) => f.isCollection)
                                  .map((g) => {
                                    const c = g.childObjectMaps.filter(
                                      (f) =>
                                        f.path?.replaceAll("/", "") ==
                                        e.fieldName?.replaceAll("/", "")
                                    );
                                    if (!isEmpty(c)) {
                                      return true;
                                    }
                                    return false;
                                  });
                                if (
                                  !isEmpty(filtered) ||
                                  groups.includes(true)
                                ) {
                                  return {
                                    ...e,
                                    mapped: true,
                                  };
                                }
                                return e;
                              })
                            : []
                        }
                        data={mappingData}
                      />
                    </Col>
                    <Col sm={8} xs={8} md={8} lg={8}>
                      {!isEmpty(targetField) && (
                        <TargetContainer
                          configurations={ct} //
                          destination={dest}
                          requiredData={targetField}
                          setFieldOperations={setFieldOperations} //
                          addConfigureSlider={addConfigureSlider}
                          onCancelConfigure={onCancelConfigure}
                          setConfigure={setConfigure}
                          deleteCT={setCT}
                          setTargetField={setTargetField}
                          ssnExist={ssnExist}
                          rkPlanNumberExist={rkPlanNumberExist}
                          dragStart={dragStart}
                          characters={characters}
                          handleOnDragEnd={handleOnDragEnd}
                          fileName={mappingData.fileName}
                        />
                      )}
                    </Col>
                  </Row>
                </div>
              </DragDropContext>
            );
          }}
        </Formik>
      </ManageTempMapLayout>
    </LoaderWrapper>
  );
};

export default MapandTransformContainer;
